import 'axios';
import 'babel-polyfill';
import 'classnames';
import 'draft-js';
import 'history';
import 'immutability-helper';
import 'katex';
import 'moment';
import 'moment-duration-format';
import 'prop-types';
import 'raf';
import 'raven-js';
import 'react';
import 'react-big-calendar';
import 'react-bootstrap';
import 'react-bootstrap-table';
import 'react-datepicker';
import 'react-dnd';
import 'react-dnd-html5-backend';
import 'react-dom';
import 'react-dropzone';
import 'react-iframe-comm';
import '@material-ui/core';
import '@material-ui/icons';
import 'react-moment';
import 'react-redux';
import 'react-router-bootstrap';
import 'react-router-dom';
import 'react-router-redux';
import 'react-rte';
import 'react-select';
import 'react-sortable-hoc';
import 'react-transition-group';
import 'react-widgets';
import 'redux';
import 'redux-form';
import 'redux-thunk';
import 'sweetalert2-react';
import 'treeview-react-bootstrap';
import 'validator';
import 'whatwg-fetch';
import 'xlsx';
import 'xmldoc';



// WEBPACK FOOTER //
// ./src/js/app/assets.js